import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=6f0e83ec&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0e83ec')) {
      api.createRecord('6f0e83ec', component.options)
    } else {
      api.reload('6f0e83ec', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=6f0e83ec&", function () {
      api.rerender('6f0e83ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27SiZDpsI1Mzy/JS/comp/ImgFallback.vue"
export default component.exports